// Tracks every EventSource opened by the app (Mercure subscriptions, async import/report
// progress streams, ...) so they can all be torn down in one place on logout. Without this,
// a connection left open past logout keeps reconnecting and sending the stale auth token.
const openEventSources = new Set<EventSource>();

export function createTrackedEventSource(
  url: string | URL,
  eventSourceInitDict?: EventSourceInit,
): EventSource {
  const eventSource = new EventSource(url, eventSourceInitDict);
  const originalClose = eventSource.close.bind(eventSource);

  eventSource.close = () => {
    openEventSources.delete(eventSource);
    originalClose();
  };

  openEventSources.add(eventSource);

  return eventSource;
}

export function closeAllEventSources(): void {
  openEventSources.forEach((eventSource) => {
    eventSource.close();
  });
}
